(function () {
  var ytPlayers = {};
  var globalMuted = true;
  var isGlobalPaused = false;
  var mainSwiper;
  var progressTimer = null;
  var nativeProgressVideo = null;
  var nativeProgressHandler = null;
  var youtubeApiPromise = window.__bleequpYoutubeApiPromise || null;

  function loadYoutubeApi() {
    if (window.YT && window.YT.Player) {
      return Promise.resolve();
    }

    if (youtubeApiPromise) {
      return youtubeApiPromise;
    }

    youtubeApiPromise = new Promise(function (resolve) {
      var previousReady = window.onYouTubeIframeAPIReady;

      window.onYouTubeIframeAPIReady = function () {
        if (typeof previousReady === 'function') {
          previousReady();
        }

        resolve();
      };

      if (!document.getElementById('bleequp-youtube-iframe-api')) {
        var script = document.createElement('script');
        script.id = 'bleequp-youtube-iframe-api';
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.head.appendChild(script);
      }
    });

    window.__bleequpYoutubeApiPromise = youtubeApiPromise;
    return youtubeApiPromise;
  }

  function loadX5NativeVideo(video) {
    if (!video || video.dataset.loaded == 'true') return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
    });
    video.load();
    video.dataset.loaded = 'true';
  }

  function stopX5ProgressTracking() {
    if (progressTimer) {
      clearTimeout(progressTimer);
      progressTimer = null;
    }

    if (nativeProgressVideo && nativeProgressHandler) {
      nativeProgressVideo.removeEventListener('timeupdate', nativeProgressHandler);
      nativeProgressVideo.removeEventListener('loadedmetadata', nativeProgressHandler);
      nativeProgressVideo.removeEventListener('ended', nativeProgressHandler);
    }

    nativeProgressVideo = null;
    nativeProgressHandler = null;
  }

  function startX5NativeProgress(video, fill) {
    if (!video || !fill) return;

    const updateProgress = () => {
      if (!video.duration) return;
      fill.style.width = Math.min((video.currentTime / video.duration) * 100, 100) + '%';
    };

    nativeProgressVideo = video;
    nativeProgressHandler = updateProgress;

    video.addEventListener('timeupdate', updateProgress);
    video.addEventListener('loadedmetadata', updateProgress);
    video.addEventListener('ended', updateProgress);
    updateProgress();
  }

  function startX5YoutubeProgress(player, fill) {
    if (!player || !fill) return;

    const updateProgress = () => {
      if (!player || typeof player.getCurrentTime !== 'function' || typeof player.getPlayerState !== 'function') return;

      if (player.getPlayerState() === 1) {
        const duration = player.getDuration();
        if (duration > 0) {
          fill.style.width = Math.min((player.getCurrentTime() / duration) * 100, 100) + '%';
        }
      }

      progressTimer = setTimeout(updateProgress, 600);
    };

    updateProgress();
  }

  // 1. YouTube 初始化与播放控制
  function initSingleYTPlayer(holder) {
    const container = holder.querySelector('.yt-player');
    if (!container) return null;
    const pId = container.id;
    const ytid = holder.dataset.ytid;

    if (!ytid || ytid.trim() === "") return null;
    if (ytPlayers[pId]) return ytPlayers[pId];
    if (typeof YT === 'undefined' || !YT.Player) {
      loadYoutubeApi().then(function () {
        initSingleYTPlayer(holder);
        if (holder.getAttribute('data-pending-play') === 'true') {
          playYT(holder);
        }
      });
      return null;
    }

    ytPlayers[pId] = new YT.Player(pId, {
      videoId: ytid,
      playerVars: {
        'autoplay': 0,
        'controls': 0,
        'mute': 1,
        'playsinline': 1,
        'rel': 0,
        'modestbranding': 1,
        'showinfo': 0
      },
      events: {
        'onReady': (e) => {
          if (holder.getAttribute('data-pending-play') === 'true') {
            playYT(holder);
          }
        },
        'onStateChange': (e) => {
          if (e.data === YT.PlayerState.PLAYING) {
            holder.classList.add('is-playing');
          }
        }
      }
    });
    return ytPlayers[pId];
  }

  function playYT(holder) {
    const ytPlayerEl = holder.querySelector('.yt-player');
    if (!ytPlayerEl) return;
    const pId = ytPlayerEl.id;
    const player = ytPlayers[pId];

    if (player && typeof player.playVideo === 'function') {
      globalMuted ? player.mute() : player.unMute();
      player.playVideo();
      holder.classList.add('is-playing');
      holder.removeAttribute('data-pending-play');
    } else {
      // 还没准备好，标记为等待播放
      holder.setAttribute('data-pending-play', 'true');
      loadYoutubeApi();
      initSingleYTPlayer(holder);
    }
  }

  // 2. 事件回调
  window.handleVideoClick = function (holder) {
    const type = holder.dataset.vtype;
    if (type === 'youtube') {
      playYT(holder);
    } else if (type === 'native') {
      const video = holder.querySelector('video');
      loadX5NativeVideo(video);
      if (video) {
        video.muted = globalMuted;
        video.play().catch(() => {});
        holder.classList.add('is-playing');
      }
    }
  };

  window.handleMuteClick = function (e, btn, idSuffix) {
    e.stopPropagation();
    globalMuted = !globalMuted;

    // 切换静音图标类名
    var sectionContainer = btn.closest('.x5-global-scope');
    if (sectionContainer) {
      sectionContainer.classList.toggle('global-unmuted', !globalMuted);
    }

    // 同步原生视频
    if (mainSwiper) {
      const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
      const video = activeSlide.querySelector('video');
      if (video) video.muted = globalMuted;
    }

    // 同步所有 YouTube 播放器
    Object.values(ytPlayers).forEach(p => {
      if (p && typeof p.mute === 'function') {
        globalMuted ? p.mute() : p.unMute();
      }
    });
  };

  // 3. Swiper 核心逻辑
  function initVideoCarousel(sectionId) {
    const scopeSelector = '#section-' + sectionId;
    const carouselRoot = document.querySelector(scopeSelector);

    if (!carouselRoot || carouselRoot.dataset.videoCarouselInitialized == 'true') return;
    if (typeof Swiper === 'undefined') return;
    carouselRoot.dataset.videoCarouselInitialized = 'true';

    mainSwiper = new Swiper(scopeSelector + ' .x5-swiper-viewport', {
      slidesPerView: 1.2,
      centeredSlides: true,
      loop: true,
      spaceBetween: 5,
      navigation: {
        nextEl: scopeSelector + ' .x5-arrow-next',
        prevEl: scopeSelector + ' .x5-arrow-prev'
      },
      breakpoints: { 768: { slidesPerView: 2.2, spaceBetween: 20 } },
      on: {
        init: function () {
          renderDots(this);
          setTimeout(() => updatePlayback(this), 500);
        },
        slideChange: function () {
          updateDots(this);
          updatePlayback(this);
        }
      }
    });

    // 渲染进度条点
    function renderDots(s) {
      const container = document.getElementById('capsule-' + sectionId);
      if (!container) return;

      // 获取真实 Slide 数量（排除 loop 产生的克隆节点）
      const realSlidesCount = s.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate')).length;

      let html = '';
      for (let i = 0; i < realSlidesCount; i++) {
        html += `<div class="x5-nav-dot" data-real-idx="${i}"><div class="x5-progress-fill"></div></div>`;
      }
      container.innerHTML = html;

      // 绑定点击事件
      container.querySelectorAll('.x5-nav-dot').forEach(dot => {
        dot.onclick = () => {
          const targetIdx = parseInt(dot.dataset.realIdx);
          s.slideToLoop(targetIdx); // 关键：使用 slideToLoop
        };
      });
    }

    // 更新进度条激活状态
    function updateDots(s) {
      const container = document.getElementById('capsule-' + sectionId);
      if (!container) return;
      const dots = container.querySelectorAll('.x5-nav-dot');

      // 使用 s.realIndex 确保即使在 loop 模式下也能准确对应
      const currentIdx = s.realIndex;

      dots.forEach((d, i) => {
        const isActive = (i === currentIdx);
        d.classList.toggle('is-active', isActive);
        // 非当前点，进度条清零
        if (!isActive) {
          const fill = d.querySelector('.x5-progress-fill');
          if (fill) fill.style.width = '0%';
        }
      });
    }

    // 处理播放、暂停及进度条动画
    function updatePlayback(s) {
      stopX5ProgressTracking();

      const scope = document.querySelector(scopeSelector);
      if (!scope) return;
      const sectionCanPlay = scope.dataset.x5CanPlay === 'true';

      // 重置所有状态
      scope.querySelectorAll('.is-playing').forEach(el => el.classList.remove('is-playing'));
      scope.querySelectorAll('video').forEach(v => { v.pause(); });
      Object.values(ytPlayers).forEach(p => {
        if (p && typeof p.pauseVideo === 'function') p.pauseVideo();
      });

      if (isGlobalPaused) return;
      if (!sectionCanPlay) return;

      // 当前活跃 Slide
      const activeSlide = s.slides[s.activeIndex];
      if (!activeSlide) return;
      const holder = activeSlide.querySelector('.x5-media-holder');
      const type = holder ? holder.dataset.vtype : null;

      // 获取当前对应的进度条 Fill 元素
      const dotsContainer = document.getElementById('capsule-' + sectionId);
      const allFills = dotsContainer ? dotsContainer.querySelectorAll('.x5-progress-fill') : [];
      const currentFill = allFills[s.realIndex];

      if (type === 'native') {
        const video = activeSlide.querySelector('video');
        if (video) {
          holder.classList.add('is-playing');
          loadX5NativeVideo(video);
          video.muted = globalMuted;
          video.play().catch(() => {});

          if (currentFill) startX5NativeProgress(video, currentFill);
        }
      } else if (type === 'youtube') {
        const ytPlayerEl = holder.querySelector('.yt-player');
        if (!ytPlayerEl) return;

        const pId = ytPlayerEl.id;
        let player = ytPlayers[pId];

        if (!player) {
          player = initSingleYTPlayer(holder);
        } else if (typeof player.playVideo === 'function') {
          globalMuted ? player.mute() : player.unMute();
          player.playVideo();
          holder.classList.add('is-playing');
        }

        if (currentFill) startX5YoutubeProgress(player, currentFill);
      }
    }

    // 4. 底部主播放/暂停按钮
    const playBtn = document.getElementById('play-pause-' + sectionId);
    if (playBtn) {
      playBtn.onclick = function () {
        isGlobalPaused = !isGlobalPaused;
        this.classList.toggle('is-paused', isGlobalPaused);
        updatePlayback(mainSwiper);
      };
    }

    const sectionRoot = document.querySelector(scopeSelector);
    if (sectionRoot) {
      const playbackObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const canPlay = entry.isIntersecting && entry.intersectionRatio >= 0.45;
            sectionRoot.dataset.x5CanPlay = canPlay ? 'true' : 'false';

            if (canPlay) {
              updatePlayback(mainSwiper);
            } else {
              stopX5ProgressTracking();
              sectionRoot.querySelectorAll('.is-playing').forEach(el => el.classList.remove('is-playing'));
              sectionRoot.querySelectorAll('video').forEach(video => video.pause());
              Object.values(ytPlayers).forEach(player => {
                if (player && typeof player.pauseVideo === 'function') player.pauseVideo();
              });
            }
          });
        },
        {
          rootMargin: '0px',
          threshold: [0, 0.45, 0.75],
        }
      );

      sectionRoot.dataset.x5CanPlay = 'false';
      playbackObserver.observe(sectionRoot);
    }
  }

  function scheduleVideoCarousel(sectionId) {
    const sectionRoot = document.querySelector('#section-' + sectionId);
    if (!sectionRoot) return;

    if (!('IntersectionObserver' in window)) {
      initVideoCarousel(sectionId);
      return;
    }

    const initObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initObserver.disconnect();
          initVideoCarousel(sectionId);
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0.01,
    });

    initObserver.observe(sectionRoot);
    sectionRoot.addEventListener('pointerdown', function () {
      initVideoCarousel(sectionId);
    }, { once: true, passive: true });
  }

  function initAll() {
    document.querySelectorAll('[data-video-carousel-id]').forEach(function (root) {
      scheduleVideoCarousel(root.getAttribute('data-video-carousel-id'));
    });
  }

  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
